/** Resolved tag objects from nested contact on deals / contacts API responses. */
export const resolveContactTags = (contact) => {
    if (!contact) return [];
    if (Array.isArray(contact.tags)) return contact.tags.filter((t) => t && (t.tag_name || t.id != null));
    return [];
};

/** Normalise GET /crm/deals/{id} payloads (flat deal or { deal, contact, tasks } wrapper). */
export const normalizeDealDetailResponse = (payload) => {
    if (!payload || typeof payload !== "object") return null;

    if (payload.deal && typeof payload.deal === "object") {
        return {
            ...payload.deal,
            contact: payload.contact ?? payload.deal.contact,
            tasks: payload.tasks ?? payload.deal.tasks,
            product_services: payload.product_services ?? payload.deal.product_services,
        };
    }

    return payload;
};
